import styles from './CardAuthor.module.css';

export default function CardAuthor({ nomeArtistico, generoLiterario, foto}) {
  return (
    <div className={styles.container}>
      <img src={foto} alt="Foto do autor" />
      <div className={styles.description}>
        <h3>{nomeArtistico}</h3>
        <p>{generoLiterario.join(', ')}</p>
      </div>
    </div>
  )
}
